"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerMedalsCard = void 0;
const TeamBadge_1 = __importDefault(require("../atoms/TeamBadge"));
const react_1 = __importStar(require("react"));
const package_1 = require("../../package");
const Person_1 = require("profile-plus/lib/shapes/Person");
require("./PlayerMedalsCard.scss");
const PlayerMedalsCard_scss_json_1 = __importDefault(require("./PlayerMedalsCard.scss.json"));
const Avatar_1 = require("profile-plus/lib/components/Avatar");
const TopicScore_1 = require("../../shapes/TopicScore");
const medal_1 = require("../../utils/medal");
const ClassNames_1 = require("lincd/lib/utils/ClassNames");
const LinkedFileStorage_1 = require("lincd/lib/utils/LinkedFileStorage");
exports.PlayerMedalsCard = (0, package_1.linkedComponent)(Person_1.Person.request((p) => ({
    givenName: p.givenName,
    familyName: p.familyName,
})), ({ onClick, source, className, linkedData: { givenName, familyName } }) => {
    let player = source;
    let [medalTotals, setMedalTotals] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        TopicScore_1.TopicScore.getAllOf(player).then((topicScores) => {
            if (topicScores) {
                let numMedals = { 1: 0, 2: 0, 3: 0 };
                topicScores.forEach((topicScore) => {
                    numMedals[topicScore.medal] += 1;
                });
                setMedalTotals(numMedals);
            }
        });
    }, []);
    return (react_1.default.createElement("div", { className: (0, ClassNames_1.cl)(PlayerMedalsCard_scss_json_1.default.PlayerMedalsCard, className), onClick: onClick },
        react_1.default.createElement("div", { className: PlayerMedalsCard_scss_json_1.default.CardHeader },
            react_1.default.createElement(Avatar_1.Avatar, { of: player, size: "small", className: PlayerMedalsCard_scss_json_1.default.avatarPersonal, fallback: react_1.default.createElement("span", null, "\u00A0") }),
            react_1.default.createElement("h4", null, (givenName ? givenName + ' ' : '') + ' ' + (familyName || ''))),
        react_1.default.createElement("div", { className: PlayerMedalsCard_scss_json_1.default.CardContent },
            react_1.default.createElement(TeamBadge_1.default, { medalImage: (0, LinkedFileStorage_1.asset)('/images/medals/generic-bronze.webp'), medalNumber: medalTotals[medal_1.BRONZE_MEDAL_NUMBER] || 0, medalDescription: "Bronze" }),
            react_1.default.createElement(TeamBadge_1.default, { medalImage: (0, LinkedFileStorage_1.asset)('/images/medals/generic-silver.webp'), medalNumber: medalTotals[medal_1.SILVER_MEDAL_NUMBER] || 0, medalDescription: "Silver" }),
            react_1.default.createElement(TeamBadge_1.default, { medalImage: (0, LinkedFileStorage_1.asset)('/images/medals/generic-gold.webp'), medalNumber: medalTotals[medal_1.GOLD_MEDAL_NUMBER] || 0, medalDescription: "Gold" }))));
});
//# sourceMappingURL=PlayerMedalsCard.js.map